import type { ThemeConfig } from "antd";

/**
 * evo-infinito Theme
 * Based on the Infinito Evolutivo logo colors:
 * - Primary (dark blue): #282a64
 * - Accent (orange): #f57526
 */
export const customTheme: ThemeConfig = {
  token: {
    // Primary colors - evo-infinito dark blue
    colorPrimary: "#282a64",
    colorPrimaryHover: "#3a3c78",
    colorPrimaryActive: "#1e1f4d",
    colorPrimaryBg: "#f0f1f8",
    colorPrimaryBgHover: "#e3e4f0",

    // Link colors - use accent orange for links
    colorLink: "#282a64",
    colorLinkHover: "#f57526",
    colorLinkActive: "#d4631f",

    // Info/accent color - orange
    colorInfo: "#f57526",
    colorInfoHover: "#ff8c42",
    colorInfoActive: "#d4631f",

    // Background colors
    colorBgContainer: "#ffffff",
    colorBgElevated: "#ffffff",
    colorBgLayout: "#f8f9fc",
    colorBgSpotlight: "#f0f1f8",

    // Border colors - subtle with blue tint
    colorBorder: "#e2e4ef",
    colorBorderSecondary: "#f1f2f8",

    // Text colors
    colorText: "#282a64",
    colorTextSecondary: "#5c5e8a",
    colorTextTertiary: "#8b8db0",
    colorTextQuaternary: "#c4c5d8",

    // Border radius - softer
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    borderRadiusXS: 4,

    // Shadows - subtle and diffused
    boxShadow:
      "0 1px 3px 0 rgba(40, 42, 100, 0.05), 0 1px 2px -1px rgba(40, 42, 100, 0.05)",
    boxShadowSecondary:
      "0 4px 6px -1px rgba(40, 42, 100, 0.05), 0 2px 4px -2px rgba(40, 42, 100, 0.05)",

    // Font family - system fonts
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",

    // Motion - smooth
    motionDurationFast: "0.15s",
    motionDurationMid: "0.2s",
    motionDurationSlow: "0.3s",

    // Line height
    lineHeight: 1.6,
  },
  components: {
    Button: {
      primaryShadow: "0 2px 4px rgba(40, 42, 100, 0.15)",
      defaultBorderColor: "#e2e4ef",
      defaultColor: "#282a64",
      fontWeight: 500,
      // Orange for danger/warning actions
      dangerColor: "#f57526",
    },
    Card: {
      headerBg: "transparent",
      boxShadowTertiary: "0 1px 3px 0 rgba(40, 42, 100, 0.05)",
    },
    Table: {
      headerBg: "#f8f9fc",
      headerColor: "#5c5e8a",
      borderColor: "#f1f2f8",
      rowHoverBg: "#f0f1f8",
    },
    Input: {
      activeBorderColor: "#282a64",
      hoverBorderColor: "#8b8db0",
    },
    Select: {
      optionSelectedBg: "#f0f1f8",
    },
    Menu: {
      itemSelectedBg: "#f0f1f8",
      itemSelectedColor: "#282a64",
      itemHoverBg: "#f0f1f8",
    },
    Tabs: {
      inkBarColor: "#f57526",
      itemSelectedColor: "#282a64",
      itemHoverColor: "#5c5e8a",
    },
    Tag: {
      defaultBg: "#f0f1f8",
      defaultColor: "#282a64",
    },
    Modal: {
      headerBg: "#ffffff",
      contentBg: "#ffffff",
    },
    Drawer: {
      colorBgElevated: "#ffffff",
    },
    Layout: {
      headerBg: "#ffffff",
      siderBg: "#ffffff",
      bodyBg: "#f8f9fc",
    },
    Tooltip: {
      colorBgSpotlight: "#282a64",
      colorTextLightSolid: "#ffffff",
    },
    Progress: {
      defaultColor: "#f57526",
    },
    Switch: {
      colorPrimary: "#282a64",
      colorPrimaryHover: "#3a3c78",
    },
  },
};

export default customTheme;
